module.exports = __webpack_public_path__ + "img/utszeliszitakoto80.ecb5b519.jpg";